import axios from "axios";
import {isArray, isObject} from "my-tools-kit";
import vuex from '../src/store'

export function getPruductTrail(data = {}){
  const url = "/api/product/listProductTrial";
  return axios.post(url, data)
    .then(res=>{
      res = isObject(res.data) ? res.data : {};
      if(res.code !== 200) return Promise.reject(new Error(res.message));
      return res;
    })
}

export function getBannerList() {
  return axios.get('/api/banner/showBanner?type=1').then(res => {
    if (res.data.code === 200) {
      vuex.commit('setBannerList', res.data.datas)
    }
  })
}

// 获取是否对外开放
export function getIsOpen() {
  axios.get('/api/datPlatformBasicSettings/getPlatformBasicSettingsIsOpen')
    .then(res => {
      if (res.data.code === 200)
        vuex.commit('changeIsOpen', res.data.data.isOpen)
    })
}



//////////////////
// WEBPACK FOOTER
// ./common/requestBaseData.js
// module id = zySD
// module chunks = 36